module.exports = __webpack_public_path__ + "img/icon-energy-consumed.df1af09d.svg";